// blakfy-cookie/src/i18n/translations/zh.js — Simplified Chinese translations

export default {
  title: "Cookie 偏好设置",
  intro: "本网站使用 Cookie 来改善您的体验。详情请查看我们的 Cookie 政策。",
  policyLink: "Cookie 政策",
  acceptAll: "接受全部",
  rejectAll: "拒绝全部",
  preferences: "偏好设置",
  save: "保存选择",
  close: "关闭",
  cat: {
    essential: { title: "必要 Cookie", desc: "网站基本功能所必需，无法禁用。", always: "始终启用" },
    analytics: { title: "分析 Cookie", desc: "用于收集匿名访问统计数据。" },
    marketing: { title: "营销 Cookie", desc: "用于个性化广告和再营销。" },
    functional: { title: "功能 Cookie", desc: "用于记住语言、主题等偏好设置。" },
  },
  placeholder: {
    title: "内容已被阻止",
    desc: "您需要允许 {category} Cookie 才能查看此内容。",
    cta: "允许",
  },
  tabs: {
    categories: "Categories",
    services: "Services",
    about: "About",
  },
  service: {
    description: "Description",
    processor: "Data Processor",
    address: "Address",
    dpo: "DPO Contact",
    purposes: "Purposes",
    technologies: "Technologies Used",
    dataCollected: "Data Collected",
    legalBasis: "Legal Basis",
    retention: "Retention Period",
    transferCountries: "Transfer Countries",
    privacyPolicy: "Privacy Policy",
    cookiePolicy: "Cookie Policy",
    legalBasisValues: {
      consent: "Consent (Art. 6 para. 1 s. 1 lit. a GDPR)",
      legitimate_interest: "Legitimate Interest (Art. 6 para. 1 s. 1 lit. f GDPR)",
    },
    noServices: "No services are configured for this site.",
  },
  svcAbout: {
    title: "About this CMP",
    description:
      "This website uses Blakfy Cookie Management Platform (CMP) to manage your consent preferences in compliance with GDPR, KVKK, CCPA and other applicable privacy regulations.",
    version: "Version",
    learnMore: "Learn more at blakfy.com",
  },
};
